export default class ClearCareerFormInputs {

    constructor() {
        this.settings = {
            $clearForm : $(".js-clear-career-form-inputs")
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$clearForm.length) {
            const clearForm = document.querySelector('.js-clear-career-form-inputs');

            clearForm.addEventListener('click', () => {

                // Reset select inputs
                document.getElementById('location').value = '';
                document.getElementById('role').value = '';
                document.getElementById('area').value = '';

                // Submit the form
                document.getElementById('filter-form').submit();

            }); 
        }
    }
};

new ClearCareerFormInputs();
